/* ============================================================
   LAB EFFECTS — Collection page region behavior
   - Client-side search / dynamic facets / quick-flags / sort over the
     server-rendered cards (mirrors the prototype's deriveFacets/deriveFlags).
   - Collection switching via the Shopify Section Rendering API: fetches
     /collections/<handle>?sections=<id>, swaps #lab-col-region in place,
     pushState + popstate + title update. Real URLs underneath.
   Loaded once (defer) and uses event delegation so it survives AJAX swaps.
   ============================================================ */
(function () {
  if (window.__labColInit) return;
  window.__labColInit = true;

  var FACET_GROUPS = [
    { key: 'category', label: 'Category', attr: 'category' },
    { key: 'aroma', label: 'Aroma Family', attr: 'aroma' },
    { key: 'terpene', label: 'Dominant Terpene', attr: 'terpene' }
  ];
  var FLAG_DEFS = [
    { key: 'best', label: 'Best Sellers', attr: 'best' },
    { key: 'new', label: 'New Arrivals', attr: 'new' },
    { key: 'sale', label: 'On Sale', attr: 'sale' },
    { key: 'stock', label: 'In Stock', attr: 'stock' }
  ];

  // per-region state, rebuilt on every init/swap
  var S = null;

  function region() { return document.getElementById('lab-col-region'); }
  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* Every grid child that is a product card. Merged tri-source products render as
     <le-merged-card class="le-mcard">, so matching only .lab-col-card silently
     excluded them from sort, search, facets and the result count. */
  var CARD_SEL = '.lab-col-card, le-merged-card';

  function cards() {
    var grid = q('[data-grid]');
    return grid ? qa(CARD_SEL, grid) : [];
  }

  /* Facet attributes are PIPE-DELIMITED lists, because a merged tri-source product
     genuinely belongs to all three categories at once (data-category="Cannabis
     Derived|Canna-Botanical Strains|Botanical Derived"). Single-valued attributes
     contain no "|" and come back as a one-item array, so every facet uses this. */
  function attrValues(card, attr) {
    return (card.getAttribute('data-' + attr) || '').split('|')
      .map(function (v) { return v.trim(); })
      .filter(function (v) { return v && v !== 'Mixed'; });
  }

  function deriveFacets(list) {
    return FACET_GROUPS.map(function (g) {
      var counts = {};
      list.forEach(function (c) {
        // dedupe within one card so a repeated value can't count that card twice
        var seen = {};
        attrValues(c, g.attr).forEach(function (v) {
          if (seen[v]) return;
          seen[v] = 1;
          counts[v] = (counts[v] || 0) + 1;
        });
      });
      var values = Object.keys(counts).sort(function (a, b) { return a.localeCompare(b); })
        .map(function (v) { return { value: v, count: counts[v] }; });
      return { key: g.key, label: g.label, attr: g.attr, values: values };
    }).filter(function (g) { return g.values.length >= 2; });
  }

  function deriveFlags(list) {
    var total = list.length;
    return FLAG_DEFS.map(function (f) {
      var count = list.filter(function (c) { return c.getAttribute('data-' + f.attr) === '1'; }).length;
      return { key: f.key, label: f.label, attr: f.attr, count: count };
    }).filter(function (f) { return f.count > 0 && f.count < total; });
  }

  function buildFilterUI() {
    var flagsWrap = q('[data-flags]'); var facetsWrap = q('[data-facets]');
    if (!flagsWrap || !facetsWrap) return;
    flagsWrap.innerHTML = S.flags.map(function (f) {
      var on = S.flagSel.indexOf(f.key) > -1;
      return '<button type="button" class="lab-col-flag' + (on ? ' is-on' : '') + '" data-flag="' + f.key + '">' +
        '<span class="lab-col-flag__box"><svg width="12" height="12" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4.75 10.75 7.9 14.6 15.25 5.75"/></svg></span>' +
        f.label + ' (' + f.count + ')</button>';
    }).join('');
    facetsWrap.innerHTML = S.facets.map(function (g) {
      var chips = g.values.map(function (v) {
        var on = (S.facetSel[g.key] || []).indexOf(v.value) > -1;
        return '<button type="button" class="lab-col-chip' + (on ? ' is-on' : '') + '" data-facet="' + g.key + '" data-value="' + escapeAttr(v.value) + '">' +
          escapeHtml(v.value) + '<span class="lab-col-chip__count">' + v.count + '</span></button>';
      }).join('');
      /* data-facet-group is a scroll target only: the mobile Aroma/Category
         chips open the sheet and jump to the matching group. Matching on the
         label text would break the moment a label is reworded. */
      return '<div class="lab-col-facetgroup" data-facet-group="' + g.key + '"><div class="lab-col-facetgroup__label">' + escapeHtml(g.label) + '</div>' +
        '<div class="lab-col-facetgroup__chips">' + chips + '</div></div>';
    }).join('');
  }

  function matches(card) {
    var query = S.query.trim().toLowerCase();
    if (query) {   // true substring keyword match over name + aroma + terpene + category + tags
      var hay = (card.getAttribute('data-keywords') ||
        [card.getAttribute('data-name'), card.getAttribute('data-aroma'), card.getAttribute('data-terpene')].join(' ')).toLowerCase();
      if (hay.indexOf(query) === -1) return false;
    }
    for (var key in S.facetSel) {
      var sel = S.facetSel[key]; if (!sel.length) continue;
      var g = FACET_GROUPS.filter(function (x) { return x.key === key; })[0];
      // OR within a group: a card qualifies if ANY of its values is selected.
      var vals = attrValues(card, g.attr);
      var hit = vals.some(function (v) { return sel.indexOf(v) > -1; });
      if (!hit) return false;
    }
    for (var i = 0; i < S.flagSel.length; i++) {
      var fk = S.flagSel[i];
      var def = FLAG_DEFS.filter(function (x) { return x.key === fk; })[0];
      if (card.getAttribute('data-' + def.attr) !== '1') return false;
    }
    return true;
  }

  function sortCards(list) {
    var s = S.sort; var a = list.slice();
    var num = function (c, attr) { return parseFloat(c.getAttribute('data-' + attr)) || 0; };
    if (s === 'best') a.sort(function (x, y) { return num(y, 'reviews') - num(x, 'reviews'); });
    else if (s === 'rated') a.sort(function (x, y) { return (num(y, 'rating') - num(x, 'rating')) || (num(y, 'reviews') - num(x, 'reviews')); });
    /* Real publish date, newest first. This used to sort on the 0/1 `new`
       flag, which only pushed tagged items to the front and left every other
       product behind them in whatever order it already had — so "New"
       looked like a filter that had stopped working. Falls back to the flag
       for any card without a date. */
    else if (s === 'new') a.sort(function (x, y) {
      return (num(y, 'published') - num(x, 'published')) || (num(y, 'new') - num(x, 'new'));
    });
    else if (s === 'price-asc') a.sort(function (x, y) { return num(x, 'price') - num(y, 'price'); });
    else if (s === 'price-desc') a.sort(function (x, y) { return num(y, 'price') - num(x, 'price'); });
    else if (s === 'az') a.sort(function (x, y) { return (x.getAttribute('data-name') || '').localeCompare(y.getAttribute('data-name') || ''); });
    return a;
  }

  function render() {
    var grid = q('[data-grid]'); if (!grid) return;
    var all = cards();
    var empty = q('[data-empty]');

    /* THE DOM REORDER ONLY RUNS WHEN THE ORDER CAN HAVE CHANGED.

       This used to run on EVERY render — so toggling one filter chip moved all
       ~879 cards with insertBefore, one at a time, before anything was painted.
       Nothing about a filter changes the order; only a new sort or newly
       loaded cards do. Comparing both is enough to catch the two cases, and it
       turns the common path (tapping a filter) from ~879 DOM moves into none.

       Skipping is safe because the DOM is already in sorted order from the
       last time it did run. */
    var ordered = all;
    if (S.lastSort !== S.sort || S.lastCount !== all.length) {
      ordered = sortCards(all);
      ordered.forEach(function (c) { grid.insertBefore(c, empty); });
      S.lastSort = S.sort;
      S.lastCount = all.length;
    }

    var shown = 0;
    ordered.forEach(function (c) {
      if (matches(c)) { c.classList.remove('is-hidden'); shown++; }
      else { c.classList.add('is-hidden'); }
    });

    grid.classList.toggle('is-empty', shown === 0);
    var cnt = q('[data-result-count]'); if (cnt) cnt.textContent = shown;
    var word = q('[data-result-word]'); if (word) word.textContent = shown === 1 ? 'result' : 'results';

    // active count + chips
    var activeCount = S.flagSel.length;
    for (var k in S.facetSel) activeCount += S.facetSel[k].length;
    var fbtn = q('[data-filter-toggle]');
    if (fbtn) { fbtn.classList.toggle('has-active', activeCount > 0); var fc = q('[data-filter-count]'); if (fc) fc.textContent = activeCount; }

    var chips = [];
    for (var gk in S.facetSel) {
      S.facetSel[gk].forEach(function (v) { chips.push({ type: 'facet', k: gk, v: v, label: v }); });
    }
    S.flagSel.forEach(function (fk) {
      var d = FLAG_DEFS.filter(function (x) { return x.key === fk; })[0];
      chips.push({ type: 'flag', k: fk, label: d ? d.label : fk });
    });
    var chipWrap = q('[data-active-chips]');
    if (chipWrap) {
      chipWrap.innerHTML = chips.map(function (c) {
        return '<button type="button" class="lab-col-activechip" data-chip-type="' + c.type + '" data-chip-k="' + escapeAttr(c.k) + '"' +
          (c.v ? ' data-chip-v="' + escapeAttr(c.v) + '"' : '') + '>' + escapeHtml(c.label) +
          '<svg width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M5 5l10 10M15 5L5 15"/></svg></button>';
      }).join('');
    }
    var activeRow = q('[data-active]');
    if (activeRow) activeRow.classList.toggle('has-chips', chips.length > 0);

    // reflect chip on-states in panel
    qa('[data-facet]').forEach(function (b) {
      var on = (S.facetSel[b.getAttribute('data-facet')] || []).indexOf(b.getAttribute('data-value')) > -1;
      b.classList.toggle('is-on', on);
    });
    qa('[data-flag]').forEach(function (b) {
      b.classList.toggle('is-on', S.flagSel.indexOf(b.getAttribute('data-flag')) > -1);
    });
    var sw = q('[data-search-wrap]'); if (sw) sw.classList.toggle('has-value', !!S.query);
  }

  function initRegion() {
    var r = region(); if (!r) return;
    var list = cards();
    S = { query: '', sort: 'featured', facetSel: {}, flagSel: [], facets: deriveFacets(list), flags: deriveFlags(list), loadedAll: false };
    /* A fresh region always carries page 1 server-side, so the loaders start at
       page 2 again. Without this reset, switching collections via the "All
       Categories" panel left nextPage at (previous pages + 1), loadAllPages /
       loadNextPage found nothing to fetch, and the new collection stopped at
       its first 48 cards with the pagination hidden ("Showing 48 results"). */
    nextPage = 2;
    pageBusy = false;
    var sortSel = q('[data-sort]'); if (sortSel) sortSel.value = 'featured';
    var searchIn = q('[data-search]'); if (searchIn) searchIn.value = '';
    buildFilterUI();
    render();
    // JS background-loads the rest, so hide the no-JS server pagination now — avoids a
    // flash of page links and accidental full-page navigation before the idle load runs.
    var pg = q('.lab-col-pagination'); if (pg) pg.style.display = 'none';
    initRail();          // (re)wire the desktop category carousel — runs on load AND after every swap
    scheduleLoadAll();   // defer the full-catalog load to idle so it never blocks first paint (eager-loads on first search/filter/sort)
  }

  /* ---------------- Desktop category carousel (collection switcher) ----------------
     Tiles are plain [data-switch-link] anchors, so the in-place swap is handled by the
     existing delegated click handler. This only adds the carousel affordances: ink-vs-white
     acronym by tile luminance, edge fades + arrow visibility, and centering the active tile.
     Re-run from initRegion() on every swap; scroll listener lives on the (replaced) track so
     it never leaks, and one window-resize listener (bound below) re-syncs the current rail. */
  /* Stepped label corners. Each label line is its own colour block; when the LAST
     line is wider than the line above it the step has to run the other way, or the
     two right-hand corners fight each other. Measured at runtime, never hardcoded
     per category (it flips on TTB and TVE). */
  function stepLabels(track) {
    qa('.lab-col-tile__label', track).forEach(function (label) {
      var lines = label.querySelectorAll('.lab-col-tile__line');
      if (!lines.length) return;
      var last = lines[lines.length - 1];
      /* The block the last line steps off is the line above it — or the acronym
         itself when the label is a single line (VES / "Vape Essentials"), which
         is why one-liners used to keep a square top-right corner. */
      var prev = lines.length > 1 ? lines[lines.length - 2] : label.querySelector('.lab-col-tile__code');
      if (!prev) return;
      var wide = last.getBoundingClientRect().width > prev.getBoundingClientRect().width + 0.5;
      if (prev !== last && prev.classList.contains('lab-col-tile__line')) prev.classList.toggle('is-grow', wide);
      last.classList.toggle('is-wide', wide);
    });
  }

  function syncRail() {
    var wrap = q('[data-le-rail]', region()); if (!wrap) return;
    var track = q('[data-le-rail-track]', wrap); if (!track) return;
    wrap.toggleAttribute('data-l', track.scrollLeft > 4);
    wrap.toggleAttribute('data-r', track.scrollLeft + track.clientWidth < track.scrollWidth - 4);
  }
  function initRail() {
    var r = region(); if (!r) return;
    var wrap = q('[data-le-rail]', r); if (!wrap) return;
    var track = q('[data-le-rail-track]', wrap); if (!track) return;
    stepLabels(track);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { stepLabels(track); });
    track.addEventListener('scroll', syncRail, { passive: true });
    var prev = q('[data-le-rail-prev]', wrap), next = q('[data-le-rail-next]', wrap);
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }); });
    // bring the active tile into view — measured, never scrollIntoView (which would jump the page)
    var on = q('[data-le-rail-active]', track);
    if (on) {
      var pad = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 28;
      var right = on.offsetLeft + on.offsetWidth;
      if (on.offsetLeft - pad < track.scrollLeft) track.scrollLeft = Math.max(0, on.offsetLeft - pad);
      else if (right + pad > track.scrollLeft + track.clientWidth) track.scrollLeft = right + pad - track.clientWidth;
    }
    syncRail();
  }
  window.addEventListener('resize', function () {
    syncRail();
    var t = q('[data-le-rail-track]', region() || document);
    if (t) stepLabels(t);
  });

  /* Defer the full-catalog load until the browser is idle so first paint isn't
     blocked; any search/filter/sort interaction triggers it eagerly (loadAllPages
     is idempotent via S.loadedAll, so calling it repeatedly is safe). */
  var nextPage = 2;
  var pageBusy = false;
  var MOBILE_MQ = window.matchMedia('(max-width: 767px)');

  /* ONE page at a time, on approach.

     Loading the whole catalogue up front puts every product in the DOM: on
     /collections/all that is ~510 cards and ~1,100 images in a single
     document. A phone cannot hold that many decoded bitmaps, so the browser
     evicts them, and evicted images have to be decoded again when they come
     back — which is exactly the "images reload when I scroll back up" and the
     hang on fast scrolling.

     Growing the grid as the shopper actually reaches the end keeps the
     document bounded at any moment AND keeps everything already loaded in
     place, so scrolling back up costs nothing. */
  function loadNextPage() {
    var r = region(); if (!r || !S || S.loadedAll || pageBusy) return;
    var total = parseInt(r.getAttribute('data-total'), 10) || 0;
    var per = parseInt(r.getAttribute('data-per'), 10) || 48;
    var pages = Math.ceil(total / per);
    if (nextPage > pages) { S.loadedAll = true; return; }

    var grid = q('[data-grid]'); var empty = q('[data-empty]');
    if (!grid) return;

    pageBusy = true;
    var page = nextPage++;
    var pg = q('.lab-col-pagination'); if (pg) pg.style.display = 'none';

    fetch(window.location.pathname + '?section_id=lab-collection-page&page=' + page, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        qa(CARD_SEL, tmp).forEach(function (c) { grid.insertBefore(c, empty); });
        var end = q('[data-grid-end]');
        if (end) grid.appendChild(end);   // keep the sentinel last
        var list = cards();
        S.facets = deriveFacets(list); S.flags = deriveFlags(list);
        buildFilterUI(); render();
        if (nextPage > pages) S.loadedAll = true;
      })
      .catch(function () {})
      .finally(function () { pageBusy = false; });
  }

  /* A sentinel at the end of the grid, a screen and a half early so the next
     batch is usually there before the shopper reaches it.

     A DEDICATED element, not [data-empty]: that one is the "no matches" panel
     and is display:none whenever there ARE results, and a zero-size element
     never intersects, so the observer never fired and the grid never grew
     past the first page. It is appended after [data-empty] and new cards are
     inserted BEFORE that, so it always stays last. */
  function watchGridEnd() {
    if (!MOBILE_MQ.matches || !('IntersectionObserver' in window)) return;
    var grid = q('[data-grid]'); if (!grid) return;
    if (q('[data-grid-end]')) return;

    var sentinel = document.createElement('div');
    sentinel.setAttribute('data-grid-end', '');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'width:100%;height:1px;';
    grid.appendChild(sentinel);

    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) loadNextPage();
    }, { rootMargin: '150% 0px' });
    io.observe(sentinel);

    /* Plus a rect check on scroll. The observer alone is not enough for two
       reasons: it does not reliably re-evaluate when the layout changes
       underneath it without a scroll, and its callbacks get deferred during
       fast flinging — which is precisely when the shopper outruns the grid and
       hits the end of it. Measuring the sentinel directly catches up in that
       case. rAF-throttled, so it costs one rect read per frame at most. */
    var scrollRaf = null, scrollTimer = null;
    function checkEnd() {
      scrollRaf = null; scrollTimer = null;
      if (!S || S.loadedAll) return;
      var el = q('[data-grid-end]'); if (!el) return;
      if (el.getBoundingClientRect().top < window.innerHeight * 2.5) loadNextPage();
    }
    /* rAF AND a setTimeout backstop, not rAF alone. requestAnimationFrame does
       not fire in a backgrounded tab and can be starved under load, and a grid
       that silently stops growing is a worse failure than one extra timer.
       Whichever lands first clears the other. */
    function queueCheck() {
      if (scrollRaf || scrollTimer) return;
      if (window.requestAnimationFrame) scrollRaf = requestAnimationFrame(checkEnd);
      scrollTimer = setTimeout(checkEnd, 150);
    }
    window.addEventListener('scroll', queueCheck, { passive: true });
    window.addEventListener('resize', queueCheck);
    // And once now, in case the first page already leaves the end in view.
    setTimeout(checkEnd, 300);
  }

  function scheduleLoadAll() {
    /* DESKTOP keeps the eager idle load — it has the memory for it and the
       behaviour is unchanged there. Mobile grows the grid on scroll instead.
       Either way any search/filter/sort still calls loadAllPages() directly,
       so those always cover the whole catalogue and never a partial one. */
    if (MOBILE_MQ.matches) { watchGridEnd(); return; }
    if ('requestIdleCallback' in window) window.requestIdleCallback(function () { loadAllPages(); }, { timeout: 2500 });
    else setTimeout(function () { loadAllPages(); }, 1000);
  }

  function clearAll() {
    S.facetSel = {}; S.flagSel = []; S.query = '';
    var searchIn = q('[data-search]'); if (searchIn) searchIn.value = '';
    buildFilterUI(); render();
  }

  /* ---------------- Load the whole collection for complete search/filter ----------------
     First paint renders only the first batch (data-per) server-side; here we fetch the
     remaining pages and append the cards so client-side search (substring, keyword) and
     filters cover every live product — not just the first batch. Deferred to idle and
     triggered eagerly on the first search/filter/sort. Page size MUST equal data-per. */
  function loadAllPages() {
    var r = region(); if (!r || !S) return;
    var total = parseInt(r.getAttribute('data-total'), 10) || 0;
    var per = parseInt(r.getAttribute('data-per'), 10) || 48;   // MUST match the section paginate size
    var pages = Math.ceil(total / per);
    if (pages <= 1 || S.loadedAll) return;
    S.loadedAll = true;
    var pg0 = q('.lab-col-pagination'); if (pg0) pg0.style.display = 'none'; // we load all pages, so drop server pagination
    var base = window.location.pathname;  // /collections/<handle> (works for the virtual "all" collection too)
    var grid = q('[data-grid]'); var empty = q('[data-empty]');
    if (!grid) return;
    var chain = Promise.resolve();
    var fetchedPage = false;
    /* Resume from nextPage, not always 2: on mobile the grid grows page by page
       as the shopper scrolls, so pages 2..k may already be in the DOM and
       starting over would append every one of them a second time. */
    var from = nextPage;
    nextPage = pages + 1;
    for (var p = from; p <= pages; p++) {
      (function (page) {
        chain = chain.then(function () {
          return fetch(base + '?section_id=lab-collection-page&page=' + page, { headers: { 'X-Requested-With': 'fetch' } })
            .then(function (res) { return res.text(); })
            .then(function (html) {
              var tmp = document.createElement('div'); tmp.innerHTML = html;
              qa(CARD_SEL, tmp).forEach(function (c) { grid.insertBefore(c, empty); });
              fetchedPage = true;
            }).catch(function () {});
        });
      })(p);
    }
    chain.then(function () {
      if (!fetchedPage) return;
      var p2 = q('.lab-col-pagination'); if (p2) p2.style.display = 'none'; // all loaded → server pagination no longer applies
      var list = cards();
      S.facets = deriveFacets(list); S.flags = deriveFlags(list);
      buildFilterUI(); render();
    });
  }

  /* ---------------- Section Rendering API switch ---------------- */
  function handleFromUrl() {
    var m = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function switchTo(handle, fromPop) {
    var r = region(); if (!r || !handle) return;
    var sectionId = r.dataset.sectionId;
    var url = '/collections/' + handle + '?sections=' + encodeURIComponent(sectionId);
    r.style.opacity = '.5';
    fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) { window.location.href = '/collections/' + handle; return; }
        var tmp = document.createElement('div');
        tmp.innerHTML = html.trim();
        var fresh = tmp.querySelector('#lab-col-region');
        if (!fresh) { window.location.href = '/collections/' + handle; return; }
        r.replaceWith(fresh);
        if (window.LESheetLock) LESheetLock.reset(); // drop any scroll-lock from an open About sheet
        /* Update the URL BEFORE initRegion: the page loaders build their fetch
           URL from window.location.pathname, and initRegion schedules them. */
        if (!fromPop) history.pushState({ handle: handle }, '', '/collections/' + handle);
        initRegion();
        var nr = region();
        if (nr && nr.dataset.title) document.title = nr.dataset.title;
        if (window.dispatchEvent) window.dispatchEvent(new CustomEvent('lab:collection-switched', { detail: { handle: handle } }));
        window.scrollTo({ top: 0, behavior: fromPop ? 'auto' : 'smooth' });
      })
      .catch(function () { window.location.href = '/collections/' + handle; });
  }

  /* ---------------- delegated events ---------------- */
  document.addEventListener('click', function (e) {
    if (!region()) return;

    if (e.target.closest('[data-totop]')) {
      e.preventDefault();
      var rmq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: rmq ? 'auto' : 'smooth' });
      return;
    }

    var sw = e.target.closest('[data-switch-link]');
    if (sw && sw.getAttribute('data-handle') && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
      e.preventDefault();
      var panel = e.target.closest('[data-switch]'); if (panel) panel.classList.remove('is-open');
      switchTo(sw.getAttribute('data-handle'), false);
      return;
    }

    var st = e.target.closest('[data-switch-toggle]');
    if (st) { e.preventDefault(); var c = q('[data-switch]'); if (c) c.classList.toggle('is-open'); return; }

    var ft = e.target.closest('[data-filter-toggle]');
    if (ft) {
      e.preventDefault();
      var open = ft.classList.toggle('is-open');
      var fp = q('[data-filter-panel]'); if (fp) fp.classList.toggle('is-open', open);
      if (open) loadAllPages();   // ensure filters cover the whole collection, not just the first batch
      return;
    }

    var flag = e.target.closest('[data-flag]');
    if (flag) {
      flag.classList.toggle('is-on');   // see the note on [data-facet] below
      var fk = flag.getAttribute('data-flag');
      var i = S.flagSel.indexOf(fk);
      if (i > -1) S.flagSel.splice(i, 1); else S.flagSel.push(fk);
      render(); return;
    }

    var facet = e.target.closest('[data-facet]');
    if (facet) {
      /* PAINT THE SELECTION FIRST.

         render() re-asserts every chip's is-on state, but it does so at the
         very END of its work — so the chip lit up only after the whole grid
         had been re-evaluated. It read as a missed tap, and the natural
         response was to tap again, which correctly toggled it back off.
         Setting it here is idempotent with what render() concludes. */
      facet.classList.toggle('is-on');
      var gk = facet.getAttribute('data-facet'), val = facet.getAttribute('data-value');
      var arr = S.facetSel[gk] || [];
      var idx = arr.indexOf(val);
      if (idx > -1) arr.splice(idx, 1); else arr.push(val);
      if (arr.length) S.facetSel[gk] = arr; else delete S.facetSel[gk];
      render(); return;
    }

    var chip = e.target.closest('[data-chip-type]');
    if (chip) {
      if (chip.getAttribute('data-chip-type') === 'flag') {
        var ck = chip.getAttribute('data-chip-k'); var ci = S.flagSel.indexOf(ck);
        if (ci > -1) S.flagSel.splice(ci, 1);
      } else {
        var ck2 = chip.getAttribute('data-chip-k'), cv = chip.getAttribute('data-chip-v');
        var a2 = S.facetSel[ck2] || []; var ai = a2.indexOf(cv);
        if (ai > -1) a2.splice(ai, 1);
        if (a2.length) S.facetSel[ck2] = a2; else delete S.facetSel[ck2];
      }
      render(); return;
    }

    if (e.target.closest('[data-clear-all]')) { e.preventDefault(); clearAll(); return; }
    if (e.target.closest('[data-search-clear]')) { S.query = ''; var si = q('[data-search]'); if (si) si.value = ''; render(); return; }

    // About slide-up: open from the hero launcher / "Read more"; close from the
    // back button, the × or the scrim.
    if (e.target.closest('[data-col-about-open]')) { e.preventDefault(); openColAbout(); return; }
    if (e.target.closest('[data-col-about-close]') || e.target.closest('[data-col-about-scrim]')) {
      e.preventDefault(); closeColAbout(); return;
    }

    var faqq = e.target.closest('[data-faq-q]');
    if (faqq) {
      var item = faqq.closest('[data-faq-item]');
      var wasOpen = item.classList.contains('is-open');
      qa('[data-faq-item]').forEach(function (it) { it.classList.remove('is-open'); });
      if (!wasOpen) item.classList.add('is-open');
      return;
    }

    // click outside switcher closes it
    if (!e.target.closest('[data-switch]')) {
      var sc = q('[data-switch]'); if (sc) sc.classList.remove('is-open');
    }
  });

  document.addEventListener('input', function (e) {
    if (!S) return;
    if (e.target.matches('[data-search]')) { loadAllPages(); S.query = e.target.value; render(); }
    else if (e.target.matches('[data-switch-search]')) {
      var term = e.target.value.trim().toLowerCase();
      var anyShown = false;
      /* Match on the ROW class, not [data-switch-link]: the menu-driven panel can
         also hold rows that aren't in-place-swappable collections (a page or
         product link has no data-handle and so no data-switch-link), and those
         must still be filterable and still hide their group when they don't match. */
      qa('.lab-col-row[data-name]').forEach(function (row) {
        var show = row.getAttribute('data-name').indexOf(term) > -1;
        row.style.display = show ? '' : 'none';
        if (show) anyShown = true;
      });
      qa('[data-switch-group]').forEach(function (grp) {
        var visible = qa('.lab-col-row', grp).some(function (r) { return r.style.display !== 'none'; });
        grp.style.display = visible ? '' : 'none';
      });
      var empty = q('[data-switch-empty]'); if (empty) empty.hidden = anyShown;
    }
  });

  document.addEventListener('change', function (e) {
    if (S && e.target.matches('[data-sort]')) { loadAllPages(); S.sort = e.target.value; render(); }
  });

  document.addEventListener('focusin', function (e) {
    if (e.target.matches('[data-search]')) { var w = e.target.closest('.lab-col-search'); if (w) w.classList.add('is-focus'); loadAllPages(); }
  });
  document.addEventListener('focusout', function (e) {
    if (e.target.matches('[data-search]')) { var w = e.target.closest('.lab-col-search'); if (w) w.classList.remove('is-focus'); }
  });

  window.addEventListener('popstate', function () {
    if (!region()) return;
    var h = handleFromUrl();
    if (h && h !== region().dataset.handle) switchTo(h, true);
  });

  function escapeHtml(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function escapeAttr(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;'); }

  /* ---------------- About slide-up (open/close) ---------------- */
  var aboutCloseTimer = null;
  function openColAbout() {
    var sheet = document.getElementById('lab-col-about-sheet');
    var scrim = q('[data-col-about-scrim]');
    if (!sheet) return;
    if (aboutCloseTimer) { clearTimeout(aboutCloseTimer); aboutCloseTimer = null; }
    if (scrim) scrim.classList.add('is-visible');
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    if (window.LESheetLock) LESheetLock.lock();
    var closeBtn = sheet.querySelector('[data-col-about-close]');
    if (closeBtn) closeBtn.focus();
  }
  function closeColAbout() {
    var sheet = document.getElementById('lab-col-about-sheet');
    var scrim = q('[data-col-about-scrim]');
    if (sheet) { sheet.classList.remove('is-open'); sheet.setAttribute('aria-hidden', 'true'); }
    if (scrim) scrim.classList.remove('is-visible');
    if (window.LESheetLock) LESheetLock.unlock();
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var sheet = document.getElementById('lab-col-about-sheet');
    if (sheet && sheet.classList.contains('is-open')) closeColAbout();
  });

  // Back-to-top: reveal after the user scrolls past ~600px (rAF-throttled).
  var totopRaf = false;
  function updateTotop() {
    totopRaf = false;
    var btn = document.querySelector('[data-totop]');
    if (!btn) return;
    if (window.pageYOffset > 600) btn.classList.add('is-visible');
    else btn.classList.remove('is-visible');
  }
  window.addEventListener('scroll', function () {
    if (!totopRaf) { totopRaf = true; requestAnimationFrame(updateTotop); }
  }, { passive: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initRegion);
  else initRegion();
  updateTotop();
})();
